<script setup>
import { trans } from '@elements/translation';
import Button from '@atoms/components/Button.vue';
import { EVENT_SLIDERS } from '../../general/event-constants';
import { PENDING_STRIPE } from '../../constants/constants';
import useInvoiceModalStore from '../../store/invoiceModal';

const props = defineProps({
  stripeAccountStatus: {
    type: String,
    required: true,
  },
});

const { setModal } = useInvoiceModalStore();

const createInvoice = () => {
  setModal({
    modalTitle: trans('gestion.invoices.slider.infos_invoices.title'),
    modalComponentName: EVENT_SLIDERS.INFOS_STRIPE_INVOICES,
    shouldOpenModal: true,
  });
};

defineExpose({
  createInvoice,
});
</script>

<template>
  <Button
    class="btn--small btn--invoice"
    variant="primary"
    :disabled="PENDING_STRIPE.includes(props.stripeAccountStatus)"
    @click="createInvoice"
  >
    {{ trans('gestion.invoices.create') }}
  </Button>
</template>
